import React, {Component} from 'react';
import ClientInfo from '../ClientInfo/ClientInfo';
import Allocations from "../Allocations/Allocations";
import IP7 from "../IP7/IP7";
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import * as actionCreators from '../../store/actionCreators';
import classes from './Planning.css';
import NumberFormat from 'react-number-format';
import PageHeader from '../../components/PageHeader/PageHeader';
import {getIndexProtectorLabel} from "../../shared/common";
import IA from "../IA/IA";

export class Planning extends Component {

    componentDidMount() {
        if (this.props.updateMenuState)
            this.props.updateMenuState();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isSubmitted) {
            this.props.history.push("/planOutput");
        }
    }

    calculate = () => {
        this.props.calculatePlan(this.props.indexProtector.indexOf("INDEX ACHIEVER") === -1 ? "IP7" : "IndexAchiever");

        window.scrollTo(0, 0);
    };

    render() {

        let invalidClasses = [classes.accountValue];

        if (this.props.accountValidInvalid) {
            invalidClasses.push(classes.invalid);
        }

        let reviewMessage = null;
        if (!this.props.isValidAccountInfo) {
            reviewMessage = (
                <div className={classes.validationMessage}>Please make sure portfolio value is between $0 and $2,000,000.</div>
            );
        }else if (!this.props.isValid) {
            reviewMessage = (
                <div className={classes.validationMessage}>Please make sure you have completed all fields before calculating your plan.</div>
            );
        }

        return (
            <div className={classes.Planning}>
                {reviewMessage}
                <PageHeader title="Portfolio Information"/>
                <ClientInfo/>
                <div className={invalidClasses.join(" ")}>
                    <label>Portfolio Value:</label>
                    <NumberFormat
                        value={this.props.accountValue}
                        onValueChange={(values) => this.props.updateAccountInfo(values.value)}
                        onClick={() => this.props.updateAccountInfo("CLICK")}
                        onBlur={() => this.props.updateAccountInfo("BLUR")}
                        displayType={'input'}
                        thousandSeparator={true}
                        prefix={'$'}
                    />
                </div>
                <PageHeader title="Current Allocation"/>
                <Allocations/>
                <PageHeader title="Fee-Based Annuity"/>
                {this.props.indexProtector.indexOf("INDEX ACHIEVER") === -1 && (
                    <React.Fragment>
                        <IP7/>
                        <p className={"smallPrint"}>
                            *The {getIndexProtectorLabel(this.props.indexProtector)} also offers a declared rate strategy, which earns interest at a fixed interest rate that is set at the
                            beginning of each term. You are not able to make hypothetical allocations to the declared rate strategy when using this calculator.
                        </p>
                    </React.Fragment>
                )}
                {this.props.indexProtector.indexOf("INDEX ACHIEVER") !== -1 && (
                    <React.Fragment>
                        <IA/>
                        <p className={"smallPrint"}>
                            *The {getIndexProtectorLabel(this.props.indexProtector)} also offers a declared rate strategy, which earns interest at a fixed interest rate that is set at the
                            beginning of each term. You are not able to make hypothetical allocations to the declared rate strategy when using this calculator.
                        </p>
                    </React.Fragment>
                )}
                <button onClick={this.calculate} className={classes.calculateButton}>CALCULATE</button>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accountValidInvalid: state.planInfo.accountInfo.invalid,
        accountValue: state.planInfo.accountInfo.value,
        isValid: state.planInfo.isValid,
        isValidAccountInfo: !state.planInfo.accountInfo.invalid,
        isSubmitted: state.planInfo.isSubmitted,
        advisorId: state.registrationState.registration.advisorInfo.advisorId,
        indexProtector: state.globalState.indexProtector
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAccountInfo: (value) => dispatch({type: actionTypes.ACCOUNT_UPDATE, value: value}),
        updateMenuState: () => dispatch({type: actionTypes.MENU_PLANNING}),
        calculatePlan: (type) => dispatch(actionCreators.calculatePlan(type))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Planning);


// WEBPACK FOOTER //
// ./src/containers/Planning/Planning.js